import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

/**
 * AdminRoute - Protects admin routes
 * Redirects to admin login if not authenticated as admin
 * Preserves intended destination for post-login redirect
 */
const AdminRoute = ({ children }) => {
  const {
    user: adminUser,
    loading,
    isInitialized,
  } = useSelector((state) => state.adminAuth);
  const adminToken = localStorage.getItem("adminAuthToken");
  const location = useLocation();

  // Show loading spinner while auth state is being determined
  if (!isInitialized || loading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gray-100">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
      </div>
    );
  }

  // Check if admin is authenticated
  if (!adminToken || !adminUser) {
    // Save the current location for redirect after login
    return <Navigate to="/admin/login" state={{ from: location }} replace />;
  }

  // Admin is authenticated, render the protected route
  return children;
};

export default AdminRoute;
